import AddAttachmentModal from './AddAttachmentModal'

export default AddAttachmentModal
